import React from 'react'

import TextArea from '../Fields/TextArea'
import Checkbox from '../Fields/Checkbox'
import classes from './layout.css'

const ModuleThirtyTwo = (props) => {
	
	return (
		<div>
			<p>I hereby authorize Dr. Esposito and staff to perform the following procedure:</p>
			<TextArea
				controlFunc={props.addToForm}
				inputType={"text"}
				name={"procedure"}
				value={props.consentForm.procedure}
				placeholder={"Vestibuloplasty with split thickness skin graft vs. palatal graft"}
			/>
			<p>and to administer the anesthesia I have chosen, which is:</p>
			<div className={classes.Anesthesia}>
				<Checkbox 
					controlFunc={props.addToForm}
					name={"anesthesiaOptions"}
					id={"1"}
					value={props.consentForm.anesthesiaOptions[1]}
				/>Local Anesthesia<br/>

				<Checkbox
					controlFunc={props.addToForm}
					name={"anesthesiaOptions"}
					id={"2"}
					value={props.consentForm.anesthesiaOptions[2]}
				/>Local Anesthesia with Nitrous Oxide/Oxygen Analgesia<br />

				<Checkbox
					controlFunc={props.addToForm}
					name={"anesthesiaOptions"}
					id={"3"}
					value={props.consentForm.anesthesiaOptions[3]}
				/>Local Anesthesia with Oral Premedication<br />

				<Checkbox
					controlFunc={props.addToForm}
					name={"anesthesiaOptions"}
					id={"4"}
					value={props.consentForm.anesthesiaOptions[4]}
				/>Local Anesthesia with Intravenous Sedation<br />

				<Checkbox
					controlFunc={props.addToForm}
					name={"anesthesiaOptions"}
					id={"5"}
					value={props.consentForm.anesthesiaOptions[5]}
				/>General Anesthesia
			</div>
			<p>Other treatment options:
				<TextArea
					controlFunc={props.addToForm}
					inputType={"text"}
					name={"otherTreatmentOptions"}
					value={props.consentForm.otherTreatmentOptions}
				/>
			</p>
		</div>
	)
}

export default ModuleThirtyTwo


// WEBPACK FOOTER //
// ./src/components/Modules/32.js